import { Errors, request } from "#/utils/request";

interface IGetVendasCadastroPropostaVenda {
  codigoComissionado: string;
  idSimulacao: number;
  name: string;
  documento: string;
  phone: string;
  email: string;
  agencia: string;
  account: string;
}

export interface IGetVendasCadastroPropostaVendaData {
  data: Data;
  errors: Errors;
}

export interface Data {
  documentId: number;
  documentTypeId: number;
}

export const getVendasCadastroPropostaVenda = async ({
  codigoComissionado,
  idSimulacao,
  name,
  documento,
  phone,
  email,
  agencia,
  account,
}: IGetVendasCadastroPropostaVenda) =>
  (
    await request.post<IGetVendasCadastroPropostaVendaData>(
      `/vendas/cadastrar-proposta-venda`,
      {
        codigoComissionado: codigoComissionado,
        idSimulacao: idSimulacao,
        name: name,
        cpfCnpj: documento,
        phone: phone,
        email: email,
        coop: agencia,
        account: account,
      }
    )
  ).data;
